import { Component, render } from 'preact';
import Common from '/common.jsx';

export default class Map extends Common {

  providers = {
    'Carto Dark':{
      url:'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png', 
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      maxZoom: 20
    },
    'ArcGIS Sat':{
      url:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', 
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      maxZoom: 19
    }
  };


}
  